import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.scss'
import './styles/desktop.scss'
import './styles/modern-theme.scss'

// React Markdown uses Object.entries internally. It is an ES2017 API, while
// this app deliberately supports ES2016-era embedded browsers.
if (!Object.entries) {
  Object.entries = ((value: Record<string, unknown>) => Object.keys(value).map(key => [key, value[key]] as [string, unknown])) as typeof Object.entries
}

const root = document.getElementById('root')
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
